<template>
<v-dialog
    v-model="dialog"
    :max-width="max_width"
    @click:outside="onCancel"
    @keydown.esc="onCancel"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>
            <div
                style="text-align: center"
            >
                <v-text-field v-if="use_native" v-model="time" type="time" label="Select Time" autofocus @keydown.enter="onEnter" />
                <v-time-picker v-else v-model="time" ampm-in-title autofocus />
            </div>
        </v-card-text>

        <v-card-actions>

            <v-btn
                text
                @click="onClickUnset"
                v-if="optional"
            >
                {{unset_label}}
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="time == null"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
export default {

    props: {
        title: {
            type: String,
            default: function() { return 'Title'; }
        },

        value: {
            type: [Number, String],
            default: function() { return null; }
        },

        optional: {
            type: Boolean,
            default: function() { return false; }
        },

        unset_label: 
        {
            type: String,
            default: function() { return 'Unset'; }
        },

        max_width: {
            type: [Number, String],
            default: 600
        },

        /**
         * If true, use native HTML time picker instead of Vuetify's.
         */
        use_native: {
            type: Boolean,
            default: function() { return false; }
        }
    },

    data() {
        return {
            dialog: false,
            time: null,
        }
    },

    methods: {

        showDialog(set_time)
        {
            let value = this.value;

            if ( set_time != null ) value = set_time;

            if ( value == null )
            {
                this.time = null;
            }
            else
            {
               this.time = value;
            }

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok', this.time);
        },

        onCancel()
        {
            this.dialog = false;
            this.$emit('cancel');
        },

        onClickUnset()
        {
            this.dialog = false;
            this.$emit('ok', null);
        },

        onEnter()
        {
            if (this.time != null) {
                this.onOk();
            }
        }

    },
}
</script>

<style lang="scss" scoped>
</style>